var map = {
	"./add.svg": "4d35",
	"./address-company.svg": "0bd0",
	"./address-home.svg": "e79a",
	"./address-school.svg": "8d02",
	"./advertisement-pool.svg": "137a",
	"./aircraft.svg": "5ccf",
	"./alipay-icon.svg": "c0c3",
	"./all-orders.svg": "527f",
	"./anchor-point.svg": "cfa2",
	"./arrow-down.svg": "2bc2",
	"./arrow.svg": "0c3c",
	"./be-delivered.svg": "edb9",
	"./bell-icon-blak.svg": "1a5f",
	"./bell-icon.svg": "f633",
	"./businessmen-stationed.svg": "3e4c",
	"./calendar-wallet-order.svg": "2dfb",
	"./chain-cat-boutique.svg": "72bf",
	"./chain-cat-member.svg": "647c",
	"./close-popup.svg": "ad8b",
	"./cm-area.svg": "3746",
	"./coin-pay.svg": "403b",
	"./collar-cm.svg": "a1cc",
	"./consumption-pool.svg": "3be8",
	"./copy-link.svg": "4f4c",
	"./correct.svg": "2af3",
	"./coupon-svg.svg": "a674",
	"./courier.svg": "cfba",
	"./customer-service.svg": "ef8a",
	"./dialog-close.svg": "7db9",
	"./feedback-svg.svg": "df39",
	"./gray-btn.svg": "66f8",
	"./green-btn.svg": "f8ee",
	"./heart-full.svg": "a22f",
	"./heart-null-black.svg": "0f86",
	"./heart-null.svg": "7ad6",
	"./help-center.svg": "38fe",
	"./hot.svg": "3e60",
	"./icon-alertwarn.svg": "c256",
	"./icon-delete.svg": "1fdc",
	"./left-btn.svg": "0571",
	"./logistics-logo.svg": "d9cc",
	"./message-center.svg": "de57",
	"./message-round.svg": "9023",
	"./mini-right-btn.svg": "1d84",
	"./my-assets.svg": "87c7",
	"./my-complaint.svg": "1a42",
	"./my-reminder.svg": "e6bf",
	"./node-application.svg": "9d14",
	"./node-pool.svg": "a2f9",
	"./notice-wallet.svg": "44ca",
	"./order-info.svg": "4c5a",
	"./pay-success.svg": "0abf",
	"./pending-pay.svg": "94a4",
	"./pending-receipt.svg": "1e2b",
	"./point.svg": "b6be",
	"./pool-count.svg": "cbef",
	"./processbar.svg": "853c",
	"./product-help.svg": "e6f7",
	"./qq-icon.svg": "4ab2",
	"./qq-space.svg": "e096",
	"./question-mark.svg": "5ab9",
	"./red-flag.svg": "a84d",
	"./right-arrow.svg": "46f2",
	"./search.svg": "385a",
	"./setting.svg": "3522",
	"./share-btn-black.svg": "6a8f",
	"./share-btn.svg": "2cb2",
	"./sharing-links.svg": "eef7",
	"./shipped.svg": "54e6",
	"./shipping-address.svg": "faf5",
	"./shopping-cart.svg": "2f23",
	"./sigh.svg": "c25a",
	"./therr-point.svg": "8ea0",
	"./transparent-btn.svg": "269b",
	"./wallet-balance-icon.svg": "af34",
	"./wallet-balance.svg": "86f1",
	"./wallet-consumption-icon.svg": "4b40",
	"./wallet-consumption.svg": "35b3",
	"./wallet-four-big.svg": "5f73",
	"./wallet-four.svg": "5e52",
	"./wallet-one-big.svg": "d28a",
	"./wallet-one.svg": "8dfb",
	"./wallet-order-message.svg": "7482",
	"./wallet-right-arrow.svg": "6c7d",
	"./wallet-right-gray-arrow.svg": "6467",
	"./wallet-three-big.svg": "aa24",
	"./wallet-three.svg": "b90c",
	"./wallet-two-big.svg": "4326",
	"./wallet-two.svg": "559f",
	"./we-blog.svg": "2d84",
	"./we-char.svg": "10da",
	"./we-chat-friends.svg": "7dca",
	"./white-btn.svg": "9f1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e795";